/** The full page shown while the app starts: the rabbit head over a slow glow, and the wordmark. */
import type { ReactNode } from 'react';
import { RabbitHead, Wordmark } from './Brand';

export function StartupScreen({ label, children }: { label: string; children?: ReactNode }) {
  return (
    <div className="om-startup" role="status" aria-label={label}>
      <div className="om-startup-mark">
        <span className="om-startup-glow" aria-hidden="true" />
        <RabbitHead width={120} />
      </div>
      <Wordmark height={14} label="" />
      {children}
    </div>
  );
}
